<div class="mb-2">
  <!-- <div class="wrapper">	
    <div class="arrow-steps">
        <div class="step current"> <span> Step 1</span> </div>
        <div class="step"> <span>Step 2 some words</span> </div>
        <div class="step"> <span> Step 3</span> </div>
        <div class="step"> <span>Step 4</span> </div>
    </div>
    </div> -->
  <header>
    <div class="arrow-steps clearfix d-flex">
      <ng-container *ngFor="let step of steps; let i = index;">
        <div [ngClass]="{'step text-wrap btn':true,
        'btn-danger': (getIsTouched(step) && !getIsValid(step) && selectedIndex != i), 
        'btn-primary': (selectedIndex == i),
         'btn-success': (getIsTouched(step) && getIsValid(step) && selectedIndex != i),
          'btn-secondary': ((!getIsTouched(step))  && selectedIndex != i)}" (click)="onClick(i)">
          <div *ngIf="step.stepLabel; else showLabelText">
            <ng-container [ngTemplateOutlet]="step.stepLabel.template">
            </ng-container>
          </div>

          <ng-template #showLabelText>
            <span
              [ngClass]="{'text-white':true, 'text-black':((!getIsTouched(step))  && selectedIndex != i)}">{{step.label}}</span>
            <!-- <div>
              <div class="card text-white ">
                <div [ngClass]="{'card-body p-1 clearfix btn':true, 
                'btn-outline-danger': (getIsTouched(step) && !getIsValid(step) && selectedIndex != i), 
                'btn-outline-primary': (selectedIndex == i),
                 'btn-outline-success': (getIsTouched(step) && getIsValid(step) && selectedIndex != i),
                  'btn-outline-secondary': ((!getIsTouched(step))  && selectedIndex != i)
                }">
                <i class="fa fa-exclamation-circle font-3xl float-left " *ngIf="(getIsTouched(step) && !getIsValid(step) && selectedIndex != i)"></i> 
                <i class="fa fa-circle font-3xl float-left " *ngIf="(selectedIndex == i)"></i> 
                  <i class="fa fa-check-circle font-3xl float-left " *ngIf="(getIsTouched(step) && getIsValid(step) && selectedIndex != i)"></i> 
                  <i class="fa fa-regular fa-circle font-3xl float-left " *ngIf="((!getIsTouched(step))  && selectedIndex != i)"></i> 
                  <div [ngClass]="{' mt-2 text-center':true,'stepper-font-size': step.label.length > 8}">
                    <b>{{ step.label }}</b>
                  </div>
                </div>
              </div>
              
            </div> -->
          </ng-template>
        </div>

      </ng-container>
    </div>
  </header>

</div>
<div class="card-body animated fadeIn border rounded mb-1 p-1" *ngIf="selected">
  <ng-container [ngTemplateOutlet]="selected.content">
  </ng-container>
</div>
<div class="row d-flex justify-content-between" *ngIf="selected">
  <button cdkStepperPrevious class="btn btn-outline-primary ml-3">
    <i class="fa fa-arrow-left"></i>&nbsp;&nbsp;Paso Anterior
  </button>
  <button cdkStepperNext class="btn btn-outline-primary mr-3"
    [disabled]="(selected.stepControl && !(selected.stepControl.dirty && (selected.stepControl.valid || selected.stepControl.disabled)) && !selected.optional) || (!selected.stepControl && !selected.optional)">
    Siguiente Paso&nbsp;&nbsp;<i class="fa fa-arrow-right"></i>
  </button>
</div>